import React from "react";
import PropTypes from "prop-types";
import styles from "./ProductHeader.module.css";

export default function ProductHeader({ title, description, img, children }) {
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.col}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.description}>{description}</p>
          <p className={styles.children}>{children}</p>
        </div>
        <div className={styles.col}>
          <img className={styles.img} src={require(`../../assets/${img}`)} />
        </div>
      </div>
    </div>
  );
}

ProductHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  img: PropTypes.string,
  children: PropTypes.node,
};
